import type { Unit } from '../../Unit'
import type { Validator } from '../Validator'
import { validateCompleteError, validateCompleteSuccess } from '../Validator'

export const notBlankValidator = (
    options: Validator.options
): Validator.validatorSingle<Unit.UnionFields['v'], unknown> => ({
    isAsync: false,
    validate: value => {
        if (
            typeof value === 'undefined' ||
            null === value ||
            '' === value ||
            (Array.isArray(value) && value.length === 0)
        ) {
            return validateCompleteError(options, 'Il campo è obbligatorio')
        }

        return validateCompleteSuccess()
    },
})
